import type { ComponentType } from "react";

import { cn } from "src/lib/utils";
import { Skeleton } from "src/components/ui/skeleton";

export type StatTone = "teal" | "blue" | "navy" | "amber" | "red" | "slate";

const toneClasses: Record<StatTone, string> = {
	teal: "tw-bg-teal-tint tw-text-teal",
	blue: "tw-bg-blue-tint tw-text-blue",
	navy: "tw-bg-navy-tint tw-text-navy",
	amber: "tw-bg-amber-tint tw-text-amber",
	red: "tw-bg-red-tint tw-text-red",
	slate: "tw-bg-slate-tint tw-text-slate",
};

interface StatCardProps {
	label: string;
	value: string | number;
	icon?: ComponentType<{ className?: string }>;
	tone?: StatTone;
	loading?: boolean;
	className?: string;
}

/** Prototype `.stat-card` — tinted icon tile, muted label, large value. */
const StatCard = ({ label, value, icon: Icon, tone = "teal", loading = false, className }: StatCardProps) => (
	<div className={cn("tw-rounded-lg tw-border tw-border-border tw-bg-white tw-p-4 tw-shadow-card sm:tw-px-5 sm:tw-py-[18px]", className)}>
		{Icon && (
			<div className={cn("tw-mb-3.5 tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-[10px]", toneClasses[tone])}>
				<Icon className="tw-h-5 tw-w-5" />
			</div>
		)}
		<div className="tw-mb-1.5 tw-text-[13px] tw-font-medium tw-text-text-soft">{label}</div>
		{loading ? <Skeleton className="tw-h-7 tw-w-28" /> : <div className="tw-text-[20px] tw-font-bold tw-text-text sm:tw-text-[22px]">{value}</div>}
	</div>
);

export default StatCard;
